<script>
  import CircImg from "../../assets/general/circleIMG.svelte"
  export let text;
  export let image;
  export let name;
  export let subtitle;
</script>

<main>
  <div class="text-block">
    <p>"{text}"</p>
  </div>
  <div class="bottom">
    <CircImg
    src={image}
    diameter="75px"
    alt="{name}: {subtitle}"
    />
    <div class="name-title">
      <h1>{name}</h1>
      <h2>{subtitle}</h2>
    </div>
  </div>
</main>

<style>
  .text-block {
    margin-bottom: 2rem;
    padding: 0 2rem;
    text-align: center;
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 2rem;
  }
  .name-title {
    text-align: left;
    padding-left: 1rem;
  }
  h1 {
    color: #f7931e;
    font-family: 'Oswald', sans-serif;
    font-size: 1rem;
    margin: 0;
  }
  h2 {
    font-style: italic;
    font-size: .77rem;
    color: #000;
    margin: 0;
  }
  p {
    font-size: 1rem;
    color: #000;
    margin: 0;
  }
</style>